import { render, staticRenderFns } from "./new-model-use.html?vue&type=template&id=7c926a4a&external"
import script from "./new-model-use.js?vue&type=script&lang=js&external"
export * from "./new-model-use.js?vue&type=script&lang=js&external"
import style0 from "./new-model-use.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports